module.exports = __webpack_public_path__ + "img/menu-icon-2-1.a82c401f.svg";